import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalvarsService } from 'src/app/services/globalvars.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class EditDeviceComponent implements OnInit {

  public pageId = 0;

  deviceid = ''
  description = ''
  department_id = '';
  public departments: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private rest: RestService,
    private globalvar: GlobalvarsService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.pageId = params['id'];
    });

    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    this.rest.getDepartments(tmpToken.accessToken)
    .then(value => {
      this.departments.push(value)
    })
    .catch(err => {
      this.globalvar.storeToken('');
      this.router.navigateByUrl('/logon');
    })

    this.rest.getDevice(tmpToken.accessToken, this.pageId)
      .then(value => {
        let val: any = value;
        this.deviceid = val[0].mac_address
        this.description = val[0].description
        this.department_id = val[0].department_id
      })
      .catch(err => {
        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })
  }


  save() {
    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    let device = {
      id : this.deviceid,
      description : this.description,
      department_id : this.department_id
    }

    this.rest.putDevice(tmpToken.accessToken, device, this.pageId)
    .then(value => {
      this.router.navigateByUrl('/devices');
    })
    .catch(err => {

      this.globalvar.storeToken('');
      this.router.navigateByUrl('/logon');
    })
  }

  delete() {
    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    this.rest.delDevice(tmpToken.accessToken, this.pageId)
    .then(value => {
      this.router.navigateByUrl('/devices');
    })
    .catch(err => {

      this.globalvar.storeToken('');
      this.router.navigateByUrl('/logon');
    })
  }

  cancel() {
    this.router.navigateByUrl('/devices');
  }

}
